

















/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default Vue.extend({
  name: 'IfpPicker',

  props: {
    isMailbox: {
      type: Boolean,
      default: false,
    },
    showFilterSpam: {
      type: Boolean,
      required: true,
    },
    showFilterWatching: {
      type: Boolean,
      required: true,
    },
    showFilterCreatedWithinDays: {
      type: Boolean,
      required: true,
    },
    showFilterLastUpdatedWithinDays: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    showingAll(): boolean {
      return (
        (!this.isMailbox || this.showFilterSpam) &&
        this.showFilterWatching &&
        this.showFilterCreatedWithinDays &&
        this.showFilterLastUpdatedWithinDays
      )
    },
  },

  methods: {
    showFilterAndClose(filterName: string) {
      this.$emit(`update:${filterName}`, true)
      this.handleCloseClick()
    },
    handleCloseClick() {
      // @ts-ignore
      this.$refs.dropdownRef.handleClose()
    },
  },
})
